<button (click)="openModal(template)" type="submit" name="BCQuitter" value="Quitter" title="Quitter"
  class="btn btn-form-cnaf btn-secondaire-cnaf">
  Quitter
</button>

<ng-template #template aria-hidden="true" aria-labelledby="monTitreModal">
  <!-- Modal HTML -->
  <div class="modal-header">
    <button (click)="closeModal()" aria-label="Fermer la popup" class="close-cnaf" data-dismiss="modal"
      type="button"></button>
    <div aria-level="1" class="texte-medium text-primary" id="monTitreModal" role="heading">Abandon</div>
  </div>
  <div class="modal-body" tabindex="0"
    aria-label="Vous souhaitez abandonner votre démarche en ligne. Si vous confirmez, les données que vous avez saisies seront perdues.">
    <p class="text-warning">
      <small>Vous souhaitez abandonner votre démarche en ligne.</small>
    </p>
    <p class="text-warning">
      <small>Si vous confirmez, les données que vous avez saisies seront perdues.</small>
    </p>
  </div>

  <div class="row ">
    <div class="modal-footer">
      <button (click)="closeModal()" class="btn btn-form-cnaf btn-secondaire-cnaf btn-mobile" data-dismiss="modal"
        type="button">Annuler</button>
      <button (click)="quitterAction()" class="btn btn-form-cnaf btn-majeur-cnaf btn-mobile" type="button">Confirmer</button>
    </div>
  </div>

</ng-template>
